import React, { useCallback, useState } from 'react';
import Signature from "../../components/Signature";
import styles from "./SignatureWithProgress.module.scss";
export function SignatureWithProgress(_ref) {
  let {
    children,
    percent
  } = _ref;
  const [maxWidthValue, setMaxWidthValue] = useState(0);
  const frontRef = useCallback(node => {
    if (node) {
      setMaxWidthValue(node.getBoundingClientRect().width);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Signature, {
    className: styles.back
  }, children), /*#__PURE__*/React.createElement("div", {
    ref: frontRef,
    style: {
      clip: percent >= 1 ? undefined : "rect(auto, ".concat(maxWidthValue * percent, "px, auto, auto)")
    },
    className: styles.front
  }, /*#__PURE__*/React.createElement(Signature, null, children)));
}